const UTMIFY_UTMS_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
const UTMIFY_PIXEL_SRC = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'

declare global {
  interface Window {
    pixelId?: string
  }
}

type UtmifyOptions = {
  /** UTMify pixel id. Omit to load only the UTM tracking script. */
  pixelId?: string
}

function alreadyLoaded(src: string) {
  return Boolean(document.querySelector(`script[src="${src}"]`))
}

/**
 * Loads the official UTMify scripts:
 * - UTM parameter tracking (utms/latest.js)
 * - UTMify pixel (pixel.js), only when a pixelId is provided
 *
 * Safe to call more than once: scripts are injected only if not present.
 */
export function loadUtmify(options: UtmifyOptions = {}) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  if (!alreadyLoaded(UTMIFY_UTMS_SRC)) {
    const utmsScript = document.createElement('script')
    utmsScript.src = UTMIFY_UTMS_SRC
    utmsScript.async = true
    utmsScript.defer = true
    utmsScript.setAttribute('data-utmify-prevent-xcod-sck', '')
    utmsScript.setAttribute('data-utmify-prevent-subid', '')
    document.head.appendChild(utmsScript)
  }

  if (options.pixelId && !alreadyLoaded(UTMIFY_PIXEL_SRC)) {
    window.pixelId = options.pixelId
    const pixelScript = document.createElement('script')
    pixelScript.src = UTMIFY_PIXEL_SRC
    pixelScript.async = true
    pixelScript.defer = true
    document.head.appendChild(pixelScript)
  }
}
